import qs from 'qs';
import { destroy, get, post, put } from './index';

/**
 * 1. GET /v1/travel-diary-contents
 * Récupère la liste des contenus de carnets de voyage accessibles pour l'organisation de l'utilisateur.
 * Params (Query): search, destinations, locale, page, perPage, direction, order
 */
export const getTravelDiaryContents = (params = {}) => {
  const { skip, filters, promiseFn, watchFn, ...query } = params;
  if (skip) {
    return Promise.resolve(null);
  }
  const queryObj = filters || query;
  return get(
    `/api/v1/travel-diary-contents?${qs.stringify(queryObj, { arrayFormat: 'brackets' })}`,
  );
};

/**
 * 2. GET /v1/travel-diary-contents/:id
 * Récupère les détails d'un contenu de carnet de voyage par son ID.
 * Params (Path): id (string, requis)
 * Params (Query): locale (string, optionnel)
 */
export const getTravelDiaryContent = (idOrObj, queryParams = {}) => {
  let id = idOrObj;
  let params = queryParams;

  if (typeof idOrObj === 'object' && idOrObj !== null) {
    id = idOrObj.id;
    params = idOrObj;
  }

  const { locale } = params;
  const queryString = locale ? `?${qs.stringify({ locale })}` : '';
  return get(`/api/v1/travel-diary-contents/${id}${queryString}`);
};

/**
 * 3. POST /v1/travel-diary-contents
 * Crée un nouveau contenu de carnet de voyage.
 * Code HTTP de succès: 201 Created
 * Payload (Body JSON):
 * {
 *   "title": "string (requis)",
 *   "categoryId": "string (requis)",
 *   "destinationIds": ["string"],
 *   "description": "string (requis)",
 *   "displaySequence": 0
 * }
 */
export const createTravelDiaryContent = payload => {
  const { locale, ...body } = payload || {};
  const queryString = locale ? `?${qs.stringify({ locale })}` : '';
  return post(`/api/v1/travel-diary-contents${queryString}`, body);
};

/**
 * 4. PUT /v1/travel-diary-contents/:id
 * Met à jour un contenu de carnet de voyage existant.
 * Params (Path): id (string, requis)
 * Payload (Body JSON):
 * {
 *   "title": "string (optionnel)",
 *   "categoryId": "string (optionnel)",
 *   "destinationIds": ["string"],
 *   "description": "string (optionnel)",
 *   "displaySequence": 0
 * }
 */
export const updateTravelDiaryContent = (idOrObj, payloadData) => {
  let id = idOrObj;
  let payload = payloadData;

  if (typeof idOrObj === 'object' && idOrObj !== null && !payloadData) {
    id = idOrObj.id;
    const { id: _, ...rest } = idOrObj;
    payload = idOrObj.payload || rest;
  }

  const { locale, ...body } = payload || {};
  const queryString = locale ? `?${qs.stringify({ locale })}` : '';
  return put(`/api/v1/travel-diary-contents/${id}${queryString}`, body);
};

/**
 * 5. DELETE /v1/travel-diary-contents/:id
 * Supprime (soft delete) un contenu de carnet de voyage.
 * Code HTTP de succès: 204 No Content
 * Params (Path): id (string, requis)
 */
export const deleteTravelDiaryContent = idOrObj => {
  const id =
    typeof idOrObj === 'object' && idOrObj !== null ? idOrObj.id : idOrObj;
  return destroy(`/api/v1/travel-diary-contents/${id}`);
};

/**
 * 6. POST /v1/travel-diary-contents/images
 * Stores an image of a content body and returns its public URL, so the body
 * carries a URL instead of the base64 pixels.
 * Code HTTP de succès: 201 Created
 * Params (Body): image (data URI, requis)
 */
export const uploadTravelDiaryContentImage = image =>
  post('/api/v1/travel-diary-contents/images', { image });
